import { apiClient } from '../api-client';
import { GrowthDataResponse } from '../../dtos/patientmr/growth.dto';

export class GrowthService {
  /**
   * Fetch all growth data for a patient.
   * Aggregates MEASUREMENT-type charting entries across all visits,
   * enriched with visit metadata. Normalized to metric units, sorted by date ascending.
   */
  static async getGrowthData(patientId: string): Promise<GrowthDataResponse> {
    const response = await apiClient.get<GrowthDataResponse>(
      `/patientmr/${patientId}/growth`
    );
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error('Failed to fetch growth data');
  }

}
